<template functional>
  <div
    class="field control-field"
    :class="[
      data.staticClass, 
      data.class, 
      $options.getStyle(props), 
      { 'has-addons': slots().addonLeft || slots().addonRight }
    ]"
  >

    <label
      class="label"
      v-if="props.label"
      v-text="props.label"
    ></label>

    <div class="relative">
      <div
        class="control"
        v-if="slots().addonLeft"
      >
        <slot name="addonLeft" />
      </div>

      <div
        :class="{ 
        'control': props.controlWrap,
        'has-icons-left': slots().iconLeft,
        'has-icons-right': slots().iconRight,
        'is-loading': props.loading
      }"
        class="is-expanded"
      >
        <!-- input control here -->
        <component
          v-if="props.f"
          :is="props.f"
          v-bind="data.attrs"
          v-on="listeners"
          :input-ref="props.inputRef"
          :value="props.value"
          :name="props.name"
          :class="props.fClass"
        />

        <slot v-else />

        <div
          class="icon is-left"
          v-if="slots().iconLeft"
        >
          <slot name="iconLeft" />
        </div>
        <div
          class="icon is-right"
          v-if="slots().iconRight"
        >
          <slot name="iconRight" />
        </div>

      </div>

      <div
        class="control"
        v-if="slots().addonRight"
      >
        <slot name="addonRight" />
      </div>

      <p
        class="help"
        v-if="props.help"
        v-text="props.help"
      />

      <transition
        enter-active-class="anim-turnup"
        leave-active-class="anim-turnup anim-reverse"
        mode="out-in"
      >
        <p
          class="error-message"
          v-if="$options.getErrors(props)"
          v-text="$options.getErrors(props)"
        />
      </transition>
    </div>

  </div>
</template>

<script>
export default {
  name: 'ControlField',
  props: {
    // choose field type
    fieldType: { type: String, default: () => null },
    // label field
    label: { type: String, default: () => null },
    // add help message
    help: { type: String, default: () => null },
    // use extenal function control
    f: { type: [Function, String], default: null },
    // rules define
    rules: { type: Object, default: () => null },
    // error bag
    errors: { type: Object, default: () => null },
    // name of field
    name: { type: String, default: () => null },
    // ref vue
    inputRef: { type: String, default: () => null },
    // v-model
    value: { type: null, default: () => null },
    // allow add extra control class div or not
    controlWrap: { type: Boolean, default: () => true },
    // force add class only for internal component
    fClass: { type: [String, Array], default: () => null },
    // show loading
    loading: { type: Boolean, default: () => null },
  },
  getStyle: props => {
    if (props.fieldType === '1') return 'field-style-1'
  },
  // check if has error to show
  getErrors: props => {
    if (!props.name) return false
    if (!props.errors) return false
    const collect = props.errors.collect()
    return collect[props.name] ? collect[props.name][0] : false
  },
}
</script>

<style lang="scss">
@import '@/style/inject';

.control-field {
  position: relative;

  .control {
    position: relative;
  }

  .label {
    user-select: none;
  }

  .error-message {
    background-color: $danger-fade;
    // border: solid 1px lighten($danger, 30);
    color: $danger;
    position: absolute;
    z-index: 1;
    bottom: 80%;
    right: 8px;
    padding: 1px 7px;
    font-size: $size-7;
    font-weight: $weight-medium;
    border-radius: 3px;
    box-shadow: 0 1px 5px rgba(black, 0.1);
    user-select: none;
    transition: bottom 0.1s linear;
  }

  .relative {
    position: relative;
  }

  > .relative:hover {
    > .error-message {
      bottom: 100%;
    }
  }
}
</style>
